import { EdtechAuthClient } from '@fagbokforlaget/edtech-auth-client'

export const AuthProvider = {
  EPORTAL: 'eportal',
  VIPPS: 'vipps',
} as const

export type LoginProvider = (typeof AuthProvider)[keyof typeof AuthProvider]

const addDev = () => (import.meta.env.MODE === 'development' ? '.dev' : '')
const authUrl =
  import.meta.env.VITE_AUTH_PROXY_URL ||
  `https://auth-proxy${addDev()}.edtech.fagbokforlaget.no/auth`

const providerUrls: Record<LoginProvider, string> = {
  eportal: `${authUrl}/eportaloidc/edtech/`,
  vipps: `${authUrl}/vipps/trafikkopplaring/`,
}

const makeProvider = (name: LoginProvider) => {
  const url = providerUrls[name]

  if (!url) {
    throw new Error(`Unknown provider: ${name}`)
  }

  return new EdtechAuthClient(url, window.location.origin)
}

let provider: LoginProvider = 'eportal'
let client = makeProvider(provider)

export const setProvider = (newProvider: LoginProvider) => {
  if (provider === newProvider) {
    return client
  }

  provider = newProvider
  client = makeProvider(provider)

  return client
}

export const getProvider = () => provider
export const getAuth = () => client

export const auth = {
  get token() {
    return client.token
  },

  get user() {
    return client.user
  },

  get products() {
    return client.products
  },

  authorize(...args: Parameters<EdtechAuthClient['authorize']>) {
    return client.authorize(...args)
  },

  logout(...args: Parameters<EdtechAuthClient['logout']>) {
    return client.logout(...args)
  },

  checkToken(...args: Parameters<EdtechAuthClient['checkToken']>) {
    return client.checkToken(...args)
  },

  checkAccess(...args: Parameters<EdtechAuthClient['checkAccess']>) {
    return client.checkAccess(...args)
  },

  silentLogin(...args: Parameters<EdtechAuthClient['silentLogin']>) {
    return client.silentLogin(...args)
  },

  validateToken(...args: Parameters<EdtechAuthClient['validateToken']>) {
    return client.validateToken(...args)
  },
}

export default auth
